import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PostHogProvider } from "posthog-js/react";
import * as Sentry from "@sentry/react";
import Clarity from "@microsoft/clarity";
import "./index.css";
import AppRoutes from "./app-routes.tsx";
import LayoutRoot from "./layouts/layout-root.tsx";

// Initialize Microsoft Clarity
Clarity.init("vqhqmkoo8t");

// Initialize Sentry for error tracking
Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
	release: __SENTRY_RELEASE__,
	sendDefaultPii: true,
	integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
	// Tracing
	tracesSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === "production" ? 0.1 : 1.0,
	tracePropagationTargets: ["localhost", /^https:\/\/(stage-)?api-(core|external)\.sayabout\.us/],
	// Session Replay
	replaysSessionSampleRate: import.meta.env.VITE_SENTRY_ENVIRONMENT === "production" ? 0.1 : 1.0,
	replaysOnErrorSampleRate: 1.0,
	// Enable structured logging
	enableLogs: true,
	enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<PostHogProvider
			apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
			options={{
				api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
				defaults: '2025-05-24',
				capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
				debug: import.meta.env.MODE === "development",
			}}
		>
			<LayoutRoot>
				<AppRoutes />
			</LayoutRoot>
		</PostHogProvider>
	</StrictMode>
);